module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CM-eedf0e3abd358fe42fad6a0d3c2a64b1.png";